module.exports = __webpack_public_path__ + "static/media/toyota-pin.5e6d86bc.svg";